// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__rxjbg","total":"Cart_total__GXbJw","actions":"Cart_actions__Qhqin","button--alt":"Cart_button--alt__hAzEp","button":"Cart_button__Gs78v"};